
import React from 'react';
import { 
  Database, 
  MessageSquare, 
  Globe, 
  Cloud, 
  Slack,
  Mail,
} from 'lucide-react';
import { Button } from "@/components/ui/button";
import { ArrowRight } from 'lucide-react';
import PlatformItem from './PlatformItem';

const PlatformsSection = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-secondary/20">
      <div className="container max-w-4xl mx-auto px-4">
        <div className="text-center mb-12 reveal">
          <h2 className="text-3xl md:text-4xl font-semibold mb-3">Supported Platforms</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Our solution seamlessly integrates with your existing cloud and chat platforms
          </p>
        </div>
        
        <div className="space-y-8 reveal">
          <div>
            <h3 className="text-xl font-medium mb-4 flex items-center">
              <Database className="h-5 w-5 text-primary mr-2" />
              Data Sources
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <PlatformItem icon={Globe} name="Azure" />
              <PlatformItem icon={Globe} name="AWS" />
              <PlatformItem icon={Cloud} name="Google Cloud Platform" />
            </div>
          </div>
          
          <div>
            <h3 className="text-xl font-medium mb-4 flex items-center">
              <MessageSquare className="h-5 w-5 text-primary mr-2" />
              Chat Interfaces
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <PlatformItem icon={Globe} name="Microsoft Teams" />
              <PlatformItem icon={Mail} name="Google Chat" />
              <PlatformItem icon={Slack} name="Slack" />
            </div>
          </div>
          
          <div className="flex justify-center mt-8">
            <Button asChild className="group">
              <a href="/tell-me-more">
                Ask about custom integrations
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformsSection;
